var React = require('react');

function BatteryLowLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.112 17a1 1 0 011-1h8a1 1 0 011 1v14a1 1 0 01-1 1h-8a1 1 0 01-1-1V17zm2 1v12h6V18h-6z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M.99 12.879A3 3 0 013.113 12h36a3 3 0 013 3v3h3a3 3 0 013 3v6a3 3 0 01-3 3h-3v3a3 3 0 01-3 3h-36a3 3 0 01-3-3V15a3 3 0 01.879-2.121zM3.113 14a1 1 0 00-1 1v18a1 1 0 001 1h36a1 1 0 001-1v-4a1 1 0 011-1h4a1 1 0 001-1v-6a1 1 0 00-1-1h-4a1 1 0 01-1-1v-4a1 1 0 00-1-1h-36z","key":1})]);
}

BatteryLowLight.defaultProps = {"viewBox":"0 0 49 48"};

module.exports = BatteryLowLight;

BatteryLowLight.default = BatteryLowLight;
